module.exports = __webpack_public_path__ + "assets/img/66_519_4.583b52d5.jpg";